import ContactLenConfig from "@/views/configs/contact_len/index.vue";
import ContactLenMaterialConfig from "@/views/configs/contact_len/material.vue";
import ContactLenManufacturerConfig from "@/views/configs/contact_len/manufacturer.vue";
import ContactLenLayoutConfig from "@/views/configs/contact_len/layout.vue";
import ContactLenGroupConfig from "@/views/configs/contact_len/group.vue";

export default [
  {
    path: "lentes-contato",
    name: "Cadastro de Lentes de contato",
    component: ContactLenConfig,
    redirect: {
      path: "/configuracoes/lentes-contato/materiais",
    },
    children: [
      {
        path: "materiais",
        name: "materiais lentes de contato",
        component: ContactLenMaterialConfig,
      },
      {
        path: "fabricantes",
        name: "fabricantes lentes de contato",
        component: ContactLenManufacturerConfig,
      },
      {
        path: "desenhos",
        name: "desenhos lentes de contato",
        component: ContactLenLayoutConfig,
      },
      {
        path: "caixas",
        name: "caixa lentes de contato",
        component: ContactLenGroupConfig,
      },
    ],
  },
];
